import { useEffect } from 'react';

const useChromeExtensionListener = ({ setValue, setCustomerValue, refSalesEntries, reCalculateTotals, t }) => {

    useEffect(() => {
        const listener = (msg) => {
            const mess = msg.data;
            if (mess.source !== "timologic") return;

            let customerName = mess.sale.customerName;
            if (customerName == null) {
                customerName = mess.sale.customerFirstName + " " + mess.sale.customerLastName;
            }

            const customer = { label: customerName, value: customerName };
            const city = mess.sale.customerCity;
            const address = mess.sale.customerAddress;
            const postalCode = mess.sale.postalCode;
            const taxpayerId = mess.sale.customerTaxPayerId;
            const addressNumber = mess.sale.addressNumber;
            const subjectField = mess.sale.subjectField;

            const entries = [];
            if (mess.sale.products) {
                mess.sale.products.forEach(e => {
                    const productModel = { name: e.name };
                    const product = { label: e.name, value: e.name, model: productModel };

                    let vat_enum = "VAT_" + e.vat;
                    let vat_label = e.vat;
                    if (mess.sale.vat) {
                        vat_enum = "VAT_" + mess.sale.vat;
                        vat_label = mess.sale.vat;
                    }

                    const vat = { label: vat_label, value: vat_enum };
                    const mu = { value: e.measurementUnit, label: t(e.measurementUnit) };

                    if (e.unitPriceWithVat) {
                        e.unitPrice = parseFloat(e.unitPriceWithVat / (1 + vat_label / 100));
                    }

                    const priceWithoutVat = parseFloat(e.quantity * e.unitPrice);
                    const unitPriceWithVat = e.unitPrice * (1 + vat_label / 100);
                    const priceWithVat = parseFloat(unitPriceWithVat * e.quantity).toFixed(2);

                    const entry = {
                        product,
                        unitPrice: parseFloat(e.unitPrice).toFixed(2),
                        unitPriceWithVat: parseFloat(unitPriceWithVat).toFixed(4),
                        quantity: e.quantity,
                        measurementUnit: mu,
                        vat,
                        discount: "0.00",
                        priceWithoutVat: priceWithoutVat.toFixed(2),
                        priceWithVat,
                    };

                    if (entry.product.value) entries.push(entry);
                });
            }

            refSalesEntries.current.setData(entries);
            reCalculateTotals();

            if (taxpayerId) setValue("taxpayerId", taxpayerId);
            if (customer) { setValue("customer", customer); setCustomerValue(customer); }
            if (city) setValue("city", city);
            if (address) setValue("fulladdress", address);
            if (postalCode) setValue("postalCode", postalCode);
            if (addressNumber) setValue("addressNumber", addressNumber);
            if (subjectField) setValue("subjectField", subjectField);
        };

        window.addEventListener("message", listener, false);
        return () => window.removeEventListener("message", listener);
    }, []);
};

export default useChromeExtensionListener;
